import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自漫画爱好者们的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="flex flex-col gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, si) => (
                  <i
                    key={si}
                    className={`text-xs md:text-sm ${
                      si < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
                &ldquo;{item.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-2 border-t border-background-200/60">
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-semibold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}